import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pulse",
  "use": "icon-pulse-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-pulse\"><path d=\"M8.375 2.25L6.646 9.281 6.369 8.25H3.546a1.5 1.5 0 00-2.357-.31 1.5 1.5 0 102.359 1.81h1.671l.806 3h1.312l1.514-6.155L10.19 15h1.324l1.094-5.25h1.845a1.5 1.5 0 002.357.31 1.5 1.5 0 10-2.359-1.81h-3.061l-.43 2.057L9.677 2.25H8.375z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol